import { render, staticRenderFns } from "./IconWarning.vue?vue&type=template&id=98b9f9fa&scoped=true&"
import script from "./IconWarning.vue?vue&type=script&lang=js&"
export * from "./IconWarning.vue?vue&type=script&lang=js&"
import style0 from "./IconWarning.vue?vue&type=style&index=0&id=98b9f9fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b9f9fa",
  null
  
)

export default component.exports